module.exports = __webpack_public_path__ + "static/Symphonia5-a867539fd23795e297b5ada1ca289c4e.webp";